(ns practitest.frontend.common.types
  (:require [clojure.set]))

(def backend->frontend-types
  {:QtestRun    :run
   :Instance    :instance
   :QtestDesign :test
   :Suite       :testset
   :Issue       :issue
   :Requirement :requirement
   :Milestone   :milestone})

(def entity->table
  {:testset :suites
   :milestone :milestones
   :issue :issues})

(def frontend->backend-types
  (clojure.set/map-invert backend->frontend-types))

(defn frontend->backend
  "Always returns string"
  [type]
  (name (get frontend->backend-types (keyword type))))

(defn backend->frontend
  "Always returns keyword"
  [type]
  (let [type (keyword type)]
    ;; In some cases we use old names, in some - new, we want to support both cases
    ;; so :testset will stay :testset, but Suite will be converted to :testset
    (if (contains? frontend->backend-types type)
      type
      (get backend->frontend-types type))))

(def label-prefix
  {:run     "Run"
   :lastrun "Last Run"
   :test    "Test"
   :testset "TestSet"
   :milestone "Milestone"
   :issue     "Issue"})
